/**
 * Friend stats screen layout helpers (safe area + shared styles).
 * Dynamic inset padding lives here so route files avoid inline style objects.
 */

import type { ViewStyle } from 'react-native';
import type { Theme } from '../src/theme/getTheme';
import { getFriendStatsStyles } from './_friendStats.styles';

/** Extra padding below safe-area inset for the custom stats header bar. */
export const FRIEND_STATS_HEADER_SAFE_AREA_EXTRA_PT = 8;

/**
 * Header row under StatusBar with top padding = safe area + fixed gap.
 */
export function getFriendStatsScreenHeaderBarWithSafeTop(
  theme: Theme,
  insetTop: number
): ViewStyle[] {
  const s = getFriendStatsStyles(theme);
  return [s.screenHeaderBar, { paddingTop: insetTop + FRIEND_STATS_HEADER_SAFE_AREA_EXTRA_PT }];
}
